export type A2HSEvent = any;

export const SHOW_PWA_NUDGE = 'showPWANudge';
